import { useEffect, useState } from 'react';
import Grid from '@mui/material/Grid';
import { Document, Page } from 'react-pdf';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import 'react-pdf/dist/esm/Page/TextLayer.css';
import 'react-pdf/dist/esm/pdf.worker.entry.js';
import { Button, ButtonGroup, IconButton, Tooltip } from '@mui/material';
import ArrowCircleLeftIcon from '@mui/icons-material/ArrowCircleLeft';
import ArrowCircleRightIcon from '@mui/icons-material/ArrowCircleRight';
import Typography from '@mui/material/Typography';
import DownloadIcon from '@mui/icons-material/Download';
import styled from '@emotion/styled';
import { FileBase64 } from '../model/file-base-64';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';

export interface DefaultPreviewPdfFileProps {
    file: FileBase64
}

export default function DefaultPreviewPdfFile({ props }: { props: DefaultPreviewPdfFileProps }) {
    const [numPages, setNumPages] = useState<number>(0);
    const [pageNumber, setPageNumber] = useState<number>(1);
    const [file, setFile] = useState<FileBase64>();

    const PDFDocumentWrapper = styled.div`
    canvas {
      width: 100% !important;
      height: auto !important;
    }
  `;
    useEffect(() => {
        if (props.file !== undefined) {
            setFile(props.file);
        }
    }, [props]);

    const onDocumentLoadSuccess = (props: any) => {
        setNumPages(props._pdfInfo.numPages);
    };
    const goToPrevPage = () =>
        setPageNumber(pageNumber - 1 <= 1 ? 1 : pageNumber - 1);

    const gotToFirstPage = () =>
        setPageNumber(1);


    const goToNextPage = () =>
        setPageNumber(
            pageNumber + 1 >= numPages ? numPages : pageNumber + 1,
        );

    const gotToLastPage = () =>
        setPageNumber(numPages);

    return (
        <Grid container spacing={0} sx={{
            backgroundColor: 'lightgray'
        }}>
            <Grid item xs={12} md={12} lg={12} sx={{
                m: 2,
                p: 2, display: "flex", justifyContent: 'center', backgroundColor: 'white'
            }}>
                <Grid item>
                    <ButtonGroup
                        disableElevation
                        variant="contained"
                    >
                        <Tooltip title="Primeira página">
                            <Button disabled={pageNumber === 1}
                                onClick={gotToFirstPage}>
                                <KeyboardDoubleArrowLeftIcon />
                            </Button>
                        </Tooltip>
                        <Tooltip title="Página anterior">
                            <Button variant="contained"
                                disabled={pageNumber === 1}
                                onClick={goToPrevPage}>
                                <KeyboardArrowLeftIcon />
                            </Button>
                        </Tooltip>
                    </ButtonGroup>


                </Grid>
                <Grid item xs sx={{ display: 'flex', textAlign: 'center', verticalAlign: 'center', justifyContent: 'center', alignItems: 'center' }}>
                    <Typography variant="button" sx={{ display: 'block' }} gutterBottom>Página {pageNumber} de {numPages}</Typography>
                </Grid>
                <Grid item sx={{ textAlign: 'right' }}>
                    <ButtonGroup
                        disableElevation
                
                        variant="contained"
                    >
               
                        <Tooltip title="Próxima página">
                            <Button variant="contained"
                                disabled={pageNumber === numPages}
                                onClick={goToNextPage}>
                                <KeyboardArrowRightIcon />
                            </Button>
                        </Tooltip>
                        <Tooltip title="Última página">
                            <Button disabled={pageNumber ===numPages}
                                onClick={gotToLastPage}>
                                <KeyboardDoubleArrowRightIcon />
                            </Button>
                        </Tooltip>
                    </ButtonGroup>
                </Grid>
   
                <Grid item xs justifyContent="flex-end" sx={{ textAlign: 'right' }}>
                    <Tooltip title="Baixar o arquivo">
                        <Button variant="contained" onClick={() => {
                            file?.download();
                        }} >
                            <DownloadIcon />
                        </Button>
                    </Tooltip>
                </Grid>
            </Grid>
            <Grid item xs={12} md={12} lg={12} sx={{
                p: 2, backgroundColor: 'lightgray'
            }}>
                {file !== undefined && (
                    <PDFDocumentWrapper>
                        <Document
                            file={file?.source}
                            onLoadSuccess={onDocumentLoadSuccess}
                            onLoadError={console.error}
                        >
                            <Page pageNumber={pageNumber} />
                        </Document>
                    </PDFDocumentWrapper>
                )}
            </Grid>
        </Grid>);
}